"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Resource_1 = __importDefault(require("../../Resource"));
const class_transformer_1 = require("class-transformer");
class GenericAutreCgpResponseResource extends Resource_1.default {
}
exports.default = GenericAutreCgpResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "appreciationClient", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "appreciationOperation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "modeEntreeRelation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "commentConnuConsultim", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "dateEntreeRelation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "coherenceSituationPatrimonialeEtInvestissement", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "coherenceSituationPatrimonialeEtInvestissementPrecision", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "appreciationClientCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "appreciationOperationCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "modeEntreeRelationCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "commentConnuConsultimCorporation", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "dateEntreeRelationCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "coherenceSituationPatrimonialeInvestCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericAutreCgpResponseResource.prototype, "coherenceSituationPatrimonialeInvestPrecisionCorporation", void 0);
